const VALID_QUERY_START_REGEX = /^(fin|"|')/i;

export default (str: string): boolean => {
  return VALID_QUERY_START_REGEX.test(
    str
      // remove comments and trim the string
      .replace(/\/\*[^]+?\*\//g, '')
      .trim()
  );
};
